import axios from "axios";
import Store from "../store/index.js";
import router from "../models/index/router.js";
import { sortASCII, signKeys, formatTime } from "./util.js";
import md5 from "js-md5";

const https = options => {
  const {
    baseURL,
    versionName,
    google_client_id,
    attributionInfoJson
  } = options;
  const requist = axios.create({
    baseURL: baseURL || process.env.VUE_APP_URL,
    timeout: 30000
  });
  requist.defaults.headers.post["Content-Type"] =
    "application/json;charset=UTF-8";
  requist.defaults.headers["channel"] = "com.id.kredi360";
  requist.defaults.headers["appMerchant"] = "ZF_360_CREDIT";
  requist.defaults.headers["appId"] = process.env.VUE_APP_ID;
  requist.interceptors.request.use(
    config => {
      const signObj = handleAddSign(config);
      Object.keys(signObj).forEach(k => {
        config.headers[k] = signObj[k];
      });
      let post_data = config.data ? config.data : {};
      let get_params = config.params ? config.params : {};
      if (!get_params.disLoading && !post_data.disLoading) {
        Store.commit("LoadingShow");
      }
      let token = localStorage.token
        ? localStorage.token
        : Store.state.androidToken;
      let userId = Store.state.userId || "";
      if (token) {
        config.headers["Authorization"] = token;
      }
      if (userId) {
        config.headers["userId"] = userId;
      }
      const trafficTag = Store.state.trafficTag;
      if (trafficTag) {
        config.headers["traffic-tag"] = trafficTag;
      }
      if (google_client_id) {
        config.headers["deviceInfoJson"] = JSON.stringify({
          google_client_id: google_client_id
        });
      }
      if (attributionInfoJson) {
        config.headers["attributionInfoJson"] = JSON.stringify(
          attributionInfoJson
        );
      }
      if (versionName) {
        config.headers["version-name"] = versionName;
        config.headers["registerSource"] = 0;
        config.headers["loginIp"] = "0.0.0.0";
      }
      return config;
    },
    error => {
      // console.log("start_error", error);
      return Promise.reject(error.data.error.message);
    }
  );
  requist.interceptors.response.use(
    response => {
      Store.commit("LoadingHide");
      return Promise.resolve(response.data);
    },
    error => {
      if (error.response) {
        Store.commit(
          "ToastShow",
          error.response.data.error_code
            ? `${error.response.data.error_message}`
            : error.response.statusText
        );
        if (error.response.status === 401) {
          console.log("", router);
          // localStorage.removeItem("token");
          // router.replace("/signin");
          // //
        }
        Store.commit("LoadingHide");
      } else {
        Store.commit("LoadingHide");
        Store.commit("ToastShow", error);
      }
      return Promise.reject(error);
    }
  );
  return requist;
};
const handleAddSign = data => {
  let str = "";
  const signObj = {
    method_name: "",
    request_method: "",
    merchant_no: signKeys.merchant_no,
    msg_id: signKeys.msg_id,
    app_id: signKeys.app_id,
    sign_timestamp: Date.now(),
    api_gw_public_key: signKeys.api_gw_public_key
  };
  const { url, method } = data;
  signObj.method_name = url;
  signObj.request_method = method;
  const paramObj = sortASCII(signObj, true);
  Object.keys(paramObj).forEach(item => {
    if (item === "sign_timestamp") {
      console.log(item, formatTime(paramObj[item], "yyyyMMdd"));
      str += `timestamp${paramObj[item]}`;
    } else {
      str += `${item}${paramObj[item]}`;
    }
  });
  str = `secret${signKeys.aesKey}${str}${signKeys.aesKey}secret`;
  signObj["request_sign"] = md5(str.toUpperCase());
  return signObj;
};
export default https;
